import shuffle from "lodash.shuffle";

export default function getRandom(arr, n) {
  const shuffled = shuffle(arr);

  let len = arr.length;

  if (n > len) {
    n = len;
  }

  return shuffled.slice(0, n);
}
